import { CompositeResponseError } from '@/shared/api/validation'

export function shouldShowApproveInvoiceWarningModal(err: unknown) {
  // Not a composite response error.
  if (!(err instanceof CompositeResponseError)) {
    return false
  }

  // It's the right error, but nothing to do with an approval or credit note allocation.
  if (!err.results.some(x => x.operation === 'approve_invoice' || x.operation === 'apply_credit_note_allocation')) {
    return false
  }

  // If the invoice wasn't approved, then we don't need error details.
  if (!err.successes.some(x => x.operation === 'approve_invoice')) {
    return false
  }

  return true
}
